import React from 'react';

export const Step = ({ number, label, isActive, isCompleted }) => {
  return (
    <div className="flex flex-col items-center p-2">
      <div className={`flex items-center justify-center w-8 h-8 rounded-full ${isActive ? 'bg-gray-500 text-white' : 'bg-gray-200 text-gray-500'}`}>
        {number}
      </div>
      <div className={`ml-2 ${isActive ? 'text-gray-500' : 'text-gray-300'}`}>{label}</div>
    </div>
  );
};

export const StepConnector = ({ isCompleted }) => {
  return (
    <div className={`flex-grow h-1 rounded-2xl ${isCompleted ? 'bg-gray-500' : 'bg-gray-200'}`}></div>
  );
};

// const Stepper = () => {
//   return (
//     <div className="flex items-center">
//       <Step number={1} label="填写账户信息" isActive={true} />
//       <StepConnector isCompleted={true} />
//       <Step number={2} label="验证账户信息" isActive={false} />
//       <StepConnector isCompleted={false} />
//       <Step number={3} label="注册成功" isActive={false} />
//     </div>
//   );
// };
